<template>
  <div>
    <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
      <div class="mb-3">
        <vs-input :label="$t('worktime_start')" v-model="companyWorktimeFormData.worktime_start" type="time" class="w-full"/>
        <validation-error :model-error="companyWorktimeFormErrors.worktime_start"></validation-error>
      </div>
    </div>
    <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
      <div class="mb-3">
        <vs-input :label="$t('worktime_end')" v-model="companyWorktimeFormData.worktime_end" type="time" class="w-full"/>
        <validation-error :model-error="companyWorktimeFormErrors.worktime_end"></validation-error>
      </div>
    </div>
  </div>
</template>

<script>
import Company from '@/models/Company'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Shared.CompanyWorktime.Edit',
  data () {
    return {
      companyWorktimeFormData: {
        worktime_start: '',
        worktime_end: ''
      },
      companyWorktimeFormErrors: {}
    }
  },
  computed: {
    server () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    }
  },
  mounted () {
    EventBus.$on('initCompanyWorktimeResetFormData', this.resetFormData)
    EventBus.$on('initCompanyWorktimeGetFormData', this.getFormData)
    EventBus.$on('initCompanyWorktimeUpdate', this.updateFormData)
  },
  methods: {
    resetFormData () {
      this.companyWorktimeFormData = {
        worktime_start: '',
        worktime_end: ''
      }
      this.companyWorktimeFormErrors = {}
    },
    async getFormData () {
      this.$vs.loading({container: '#companyWorktimeEditFormDataContainer'})

      const response = await Company.worktimeView()
      this.companyWorktimeFormData.worktime_start = response.data.worktime_start
      this.companyWorktimeFormData.worktime_end = response.data.worktime_end

      this.$vs.loading.close('#companyWorktimeEditFormDataContainer > .con-vs-loading')
    },
    async updateFormData () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#updateCompanyWorktimeButton', scale: 0.45})

      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await Company.worktimeUpdate(this.companyWorktimeFormData)
          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.$emit('success')
          this.resetFormData()
        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.announcementFormErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }

      this.$vs.loading.close('#updateCompanyWorktimeButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
#onUpdateCompanyWorktimeButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>

